import { useState } from 'react'
import { Button } from '../../../components/UI'

export default function MCRulesetParamsTable({ ruleset, onOverride }) {
  const [editing, setEditing] = useState(null)
  const [value, setValue] = useState('')

  if (!ruleset) return null

  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-3 py-2 text-left">Parámetro</th>
            <th className="px-3 py-2 text-left">Valor</th>
            <th className="px-3 py-2 text-left">Unidad</th>
            <th className="px-3 py-2 text-right">Acción</th>
          </tr>
        </thead>
        <tbody>
          {(ruleset.parameters || []).map((p) => (
            <tr className="border-t" key={p.paramKey}>
              <td className="px-3 py-2">{p.paramKey}</td>
              <td className="px-3 py-2">{p.paramValue}</td>
              <td className="px-3 py-2">{p.unit}</td>
              <td className="px-3 py-2 text-right">
                {editing === p.paramKey ? (
                  <div className="inline-flex gap-2">
                    <input className="w-28 rounded border px-2 py-1" type="number" step="any" value={value} onChange={(e) => setValue(e.target.value)} />
                    <Button size="sm" onClick={() => { onOverride(p.paramKey, Number(value)); setEditing(null); }}>Guardar</Button>
                  </div>
                ) : (
                  <Button size="sm" variant="outline" onClick={() => { setEditing(p.paramKey); setValue(p.paramValue); }}>Ajustar</Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
